import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { BusinessAreaService } from "../../../services/BusinessAreaService";
import { useState } from "react";
import { useEffect } from "react";
export default function BusinessAreaCreateOrEdit({
  onClose,
  businessAreaId,
  isOpen
}) {
  const [errors, setErrors] = useState({});
  const [businessArea, setBusinessArea] = useState({});
  let { t } = useTranslation();
  useEffect(() => {
    if (businessAreaId)
      BusinessAreaService.getbyId(businessAreaId).then((data) => {
        setBusinessArea(data);
      });
  }, [businessAreaId]);

  function onChange({ target }) {
    setBusinessArea({ ...businessArea, [target.name]: target.value });
  }
  function createOrUpdate() {
    if (validate()) return;
    BusinessAreaService.createOrUpdate(businessArea).then((data) => {
      setBusinessArea({});
      onClose();
    });
  }
  function validate() {
    let errors = {};
    if (!businessArea.description) errors.description = t("Required");
    setErrors(errors);
    return Object.keys(errors).length > 0;
  }

  return (
    <ModalContainer
      modalTitle={t("Create or Edit  Business Area")}
      onClose={onClose}
      submitButtonAction={createOrUpdate}
      submitButtonTitle={t("Save")}
      cancelButtonTitle={t("Cancel")}
      cancelButtonAction={onClose}
      submitButtonType="button"
      isOpen={isOpen}
    >
      <div className="form-group">
        <div className="label-wrapper">
          <label className="label">{t("Name")}</label>
          <div className="error-msg">{errors.description}</div>
        </div>
        <input
          onChange={onChange}
          className="form-control"
          name="description"
          value={businessArea.description || ""}
        />
      </div>
    </ModalContainer>
  );
}
